import { render, staticRenderFns } from "./HumanVerificationGate.vue?vue&type=template&id=9c0d06a8&scoped=true"
import script from "./HumanVerificationGate.vue?vue&type=script&lang=js"
export * from "./HumanVerificationGate.vue?vue&type=script&lang=js"
import style0 from "./HumanVerificationGate.vue?vue&type=style&index=0&id=9c0d06a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0d06a8",
  null
  
)

export default component.exports